import { Injectable } from '@angular/core';

import { AdviceDoc } from '@aa/common';
import { SelfServMetaCache } from './selfserv-meta-cache.service';

@Injectable({providedIn: 'root'})
export class ShareService {

  public readonly canShare: boolean;

  constructor(private readonly metaCache: SelfServMetaCache) {
    this.canShare = !!navigator.share;
  }

  // called by app initializer in core module
  public share(doc: AdviceDoc): void {

    if (!doc || !this.canShare) {
      console.warn('share unavailable');
      return;
    }

    const meta = this.metaCache.meta;

    navigator.share({
      title: `Housing Advice: ${doc.name}`,
      url: `${meta.url}advice/${doc.slug}`
    })
      .then(() => console.log('Successful share'))
      .catch((error) => console.log('Error sharing', error));
  }
}
